import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {KakaoCashReportDataResultVo} from '../../common/shared/api/nicolas/vo/KakaoCashReportDataVo.interface';

/**
 * 캐시 충전 내역 조회
 *
 * Origin: pageNicolasApi.getCashChargingHistory
 * API: POST /api/v1/store/cash_history/retention
 */
export async function postStoreCashHistoryRetention(
  params: {
    usePaging?: boolean;
    lastPageId?: string | null;
  },
  options?: FetcherOptions
): Promise<KakaoCashReportDataResultVo> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v1/store/cash_history/retention',
    {
      method: 'POST',
      data: {
        use_paging: params.usePaging ?? true,
        last_page_id: params.lastPageId ?? null,
      },
    },
    options
  );
  return response.data;
}
